export default __webpack_public_path__ + "static/media/DB_3.3f2bea1e.png";